/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsApplicationRunning: BridgeCommands.Command<
    Types.Common.Applicationinfo.IsApplicationRunningParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_IS_APPLICATION_RUNNING',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'IsApplicationRunning',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsApplicationInstalled: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_IS_APPLICATION_INSTALLED',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'IsApplicationInstalled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIsUIRefreshed: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_IS_UI_REFRESHED',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'GetIsUIRefreshed',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterAppLifetimeEventsCallback: BridgeCommands.Command<
    {},
    Types.Common.Applicationinfo.ApplicationLifetimeEvent
    > = {
    legacyCommand: 'QUERY_REGISTER_APPLICATION_LIFETIME_EVENTS_CALLBACK',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'RegisterAppLifetimeEventsCallback',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ListenToLoadEvents: BridgeCommands.Command<
    {},
    string
    > = {
    legacyCommand: 'QUERY_LISTEN_TO_LOAD_EVENTS',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'ListenToLoadEvents',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenFileDialog: BridgeCommands.Command<
    Types.Common.Applicationinfo.OpenFileDialogParameters,
    string
    > = {
    legacyCommand: 'QUERY_WIN_DIR_INFO',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'OpenFileDialog',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SaveFileAsDialog: BridgeCommands.Command<
    Types.Common.Applicationinfo.SaveFileAsDialogParameters,
    string
    > = {
    legacyCommand: 'QUERY_WIN_SAVE_FILE_AS',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'SaveFileAsDialog',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenDirectoryBrowser: BridgeCommands.Command<
    Types.Common.Applicationinfo.OpenDirectoryBrowserParameters,
    any
    > = {
    legacyCommand: 'QUERY_BROWSE_DIRECTORY',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'OpenDirectoryBrowser',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenSystemSetting: BridgeCommands.Command<
    Types.Common.Applicationinfo.OpenSystemSettingParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'OpenSystemSetting',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetApplicationTimeInfo: BridgeCommands.Command<
    Types.Common.Applicationinfo.GetApplicationTimeInfoParameters,
    Types.Common.Applicationinfo.GetApplicationTimeInfoReturn
    > = {
    legacyCommand: 'QUERY_TIME_INFO',
    system: 'CrimsonNative',
    module: 'ApplicationInfo',
    method: 'GetApplicationTimeInfo',
    persistent: false
};

export const Applicationinfo = {
IsApplicationRunning,
IsApplicationInstalled,
GetIsUIRefreshed,
RegisterAppLifetimeEventsCallback,
ListenToLoadEvents,
OpenFileDialog,
SaveFileAsDialog,
OpenDirectoryBrowser,
OpenSystemSetting,
GetApplicationTimeInfo
};
